import React from 'react';
import ResearchLoader from './ResearchLoader';

export default function MessageLoadingState({
  isDarkMode,
  isResearchMode,
  researchStep,
}) {
  return (
    <div className="w-full mt-3">
      <div className="max-w-4xl mx-auto w-full">
        {isResearchMode ? (
          <ResearchLoader isDarkMode={isDarkMode} researchStep={researchStep} />
        ) : (
          <div
            className={`w-full overflow-hidden rounded-xl border shadow-sm ${
              isDarkMode
                ? 'border-gray-700 bg-[#1f2937]'
                : 'border-gray-200 bg-white'
            }`}
          >
            <div
              className={`flex items-center justify-between px-4 py-3 border-b ${
                isDarkMode
                  ? 'bg-indigo-900 border-indigo-800'
                  : 'bg-indigo-50 border-indigo-100'
              }`}
            >
              <div className={`h-4 w-40 rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>

              <div className="flex gap-3">
                <div className={`h-5 w-5 rounded-md animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
                <div className={`h-5 w-5 rounded-md animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
                <div className={`h-5 w-5 rounded-md animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
              </div>
            </div>

            <div className="px-6 py-5">
              <div className={`h-5 w-44 rounded animate-pulse mb-5 ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>

              <div className="space-y-3 mb-5">
                <div className={`h-4 w-full rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
                <div className={`h-4 w-[95%] rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
                <div className={`h-4 w-[85%] rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
              </div>

              <div className="space-y-3 mb-5">
                <div className={`h-4 w-full rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
                <div className={`h-4 w-[92%] rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
                <div className={`h-4 w-[75%] rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
              </div>

              <div className="space-y-3">
                <div className={`h-4 w-full rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
                <div className={`h-4 w-[88%] rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
                <div className={`h-4 w-[70%] rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
